// react
import { ReactNode } from 'react';

// router
import { useTranslation } from 'react-i18next';

// types
import { WithdrawalApplication } from '../../../@types';

// mui
import { Link, LinkProps, Typography } from '@mui/material';

// props
export interface LinkWaProps extends LinkProps {
	children?: ReactNode;
	withdrawalApplication?: WithdrawalApplication | null;
	[x: string]: unknown;
}

export const LinkWa = ({ children, withdrawalApplication, ...props }: LinkWaProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const content = children || withdrawalApplication?.idWbg || t('na');

	if (withdrawalApplication?.urlWbg) {
		return (
			<Link
				href={withdrawalApplication.urlWbg}
				fontWeight={600}
				sx={{ wordBreak: 'break-word' }}
				target="_blank"
				underline="hover"
				{...props}>
				{content}
			</Link>
		);
	}

	return <Typography fontWeight={600}>{content}</Typography>;
};
